import ZenMode from '~/zen_mode';
import { fetchCommitMergeRequests } from '../../../../commit_merge_requests.js?vue3';
import initCherryPickCommitModal from '../../../../projects/commit/init_cherry_pick_commit_modal.js?vue3';
import initCommitOptionsDropdown from '../../../../projects/commit/init_commit_options_dropdown.js?vue3';
import initRevertCommitModal from '../../../../projects/commit/init_revert_commit_modal.js?vue3';
import initCommitPipelineSummary from '../../../../projects/commit_box/info/init_commit_pipeline_summary.js?vue3';
import initCommitReferences from '../../../../projects/commit_box/info/init_commit_references.js?vue3';
import { createCommitRapidDiffsApp } from '../../../../rapid_diffs/commit_app.js?vue3';

// eslint-disable-next-line no-new
new ZenMode();
fetchCommitMergeRequests();
initCommitPipelineSummary();
initCommitReferences();

initRevertCommitModal();
initCherryPickCommitModal();
initCommitOptionsDropdown();

const app = createCommitRapidDiffsApp();
app.init();
